import Request from './authorized-request';

export default class RssApi {
  static async fetch(options, category) {
    return Request.get('/news_links', {
      params: {
        ...options,
        category_id: category,
      },
    });
  }

  static async getConfig() {
    return Request.get('/news_links/config');
  }

  static async update(data) {
    return Request.put(`/c/news_links/${data.id}`, data);
  }

  static async remove(data) {
    return Request.delete(`/c/news_links/${data.id}`);
  }

  static async create(data) {
    return Request.post(`/c/news_links`, data);
  }
}
